import React from 'react';

export const projectDetailTabIds = {
    PROJECT: "project",
    PRODUCTS: "products",
    OBJECTS: "org-items",
    APPLIED: "applied-product",
    CARBON_FP: "carbon-fp",
    SPECS: "specs",
    ANALYTICS: "analytics",
    INDUSTRY_DATA: 'industry-data',
    DOCS: 'docs'
}

export const projectDetailsTabs = [
    { id: projectDetailTabIds.PROJECT, label: "PROJECT" },
    { id: projectDetailTabIds.OBJECTS, label: "OBJECTS" },
    { id: projectDetailTabIds.DOCS, label: "DOCS" },
    { id: projectDetailTabIds.PRODUCTS, label: "PRODUCTS" },
    { id: projectDetailTabIds.CARBON_FP, render: (<p>CO<sub>2</sub>e</p>) },
    // { id: projectDetailTabIds.SPECS, label: "SPECS"}
    // { id: projectDetailTabIds.APPLIED, label: "APPLIED" },
]

export const miniAppTabs = [
    { id: projectDetailTabIds.OBJECTS, label: "OBJECTS" },
    { id: projectDetailTabIds.SPECS, label: "DOCS" },
    { id: projectDetailTabIds.INDUSTRY_DATA, label: "INDUSTRY DATA" },
    { id: projectDetailTabIds.PRODUCTS, label: "PRODUCTS" }
]

export const projectViewerToggle = {
    "3D": "3d",
    BOM: "bom"
}

export const projectSource = {
    SAAS: "saas",
    ACC: "acc"
}
